export default {"src":"/_next/static/media/pretest.90beccc4.svg","height":357,"width":499,"blurWidth":0,"blurHeight":0};